import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink as ReactRouterLink } from "react-router-dom";

import { PhoneIcon, EmailIcon, InfoIcon, ExternalLinkIcon } from "@chakra-ui/icons";
import {
	Popover,
	PopoverTrigger,
	PopoverContent,
	PopoverHeader,
	PopoverBody,
	PopoverArrow,
	PopoverCloseButton,
	Button,
	Stack,
	Text,
	Box,
	HStack,
	Link,
	Divider,
} from "@chakra-ui/react";
import { CgProfile } from "react-icons/cg";

export default function OwnerPopover({ contact }) {
	const { t } = useTranslation();
	return (
		<Popover>
			<PopoverTrigger>
				<Button
					width={"fit-content"}
					maxW="250px"
					size={"sm"}
					variant="outline"
					_hover={{ bg: "gray.100" }}
					fontWeight="medium"
					textTransform={"capitalize"}
					leftIcon={<InfoIcon color="blue.500" />}
				>
					<Text isTruncated>{contact.name}</Text>
				</Button>
			</PopoverTrigger>
			<PopoverContent>
				<PopoverArrow />
				<PopoverCloseButton />
				<PopoverHeader fontWeight="semibold" borderBottomWidth="1px" p={4} bg="blue.50" borderTopRadius="md">
					{t("property.contactInformation")} -{" "}
					<Text as="span" color="blue.600">
						{t("table.owner")}
					</Text>
				</PopoverHeader>
				<PopoverBody py={4}>
					<Stack spacing={4} style={{ whiteSpace: "normal" }}>
						<Box>
							<HStack spacing={2} align="center">
								<CgProfile color="gray.600" />
								<Text flex="1" fontWeight="medium">
									{contact.name}
								</Text>
							</HStack>
						</Box>
						<HStack spacing={2} align="center">
							<EmailIcon color="blue.500" />
							<Text flex="1" fontWeight="medium">
								{contact.email}
							</Text>
						</HStack>
						<HStack spacing={2} align="center">
							<PhoneIcon color="green.500" />
							<Text flex="1" fontWeight="medium">
								{contact.phoneNumber}
							</Text>
						</HStack>
						{contact.phoneNumber2 && (
							<HStack spacing={2} align="center">
								<PhoneIcon color="green.500" />
								<Text flex="1" fontWeight="medium">
									{contact.phoneNumber2}
								</Text>
							</HStack>
						)}
						<Divider />
						<Link as={ReactRouterLink} to={`/owner/view/${contact.id}`} _hover={{ textDecoration: "none" }}>
							<Button width="full" colorScheme="blue" variant="ghost" size="sm" leftIcon={<ExternalLinkIcon />} _hover={{ bg: "blue.50" }}>
								{t("table.view")}
							</Button>
						</Link>
					</Stack>
				</PopoverBody>
			</PopoverContent>
		</Popover>
	);
}
